import { Component, OnInit } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {WccService} from '../../../services/wcc-service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Website} from '../../../models/website.model';
import {Promotion} from '../../../models/promotion.model';
import {DialogConfirmationComponent} from '../../../dialogs/dialog-confirmation/dialog-confirmation.component';
import {DialogNewPromotionComponent} from './dialogs/dialog-new-promotion/dialog-new-promotion.component';
import {PromotionService} from '../../../services/promotion-service';
import {DialogErrorComponent} from '../../../dialogs/dialog-error/dialog-error.component';

@Component({
  selector: 'app-streamup-website-promos',
  templateUrl: './website-promos.component.html',
  styleUrls: ['./website-promos.component.scss']
})
export class WebsitePromosComponent implements OnInit {

    loadingWebsites$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    hasWebsites$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    websites$: BehaviorSubject<Website[]> = new BehaviorSubject<Website[]>([]);
    loadingPromos$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    hasPromos$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    promosAll$: BehaviorSubject<Promotion[]> = new BehaviorSubject<Promotion[]>([]);

  constructor(
      private dialog: MatDialog,
      private wccService: WccService,
      private promotionService: PromotionService,
      public snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
      this.getWebsites();
      this.getPromotions();
  }

    getWebsites(){
        this.loadingWebsites$.next(true);
        this.wccService.getWebsites()
            .subscribe((websites: Website[]) => {
                this.websites$.next(websites);
                this.hasWebsites$.next(websites.length > 0);
                this.loadingWebsites$.next(false);
            });
    }

    updateWebsiteLinkedPromotion(website: number, promotion: number){
      this.promotionService.updateSiteLinkedPromotion(website, promotion)
          .subscribe((response: any) => {
              if (!response.error) {
                  this.getWebsites();
              } else {
                  this.snackBar.open('An error occurred!', null, {duration: 1000});
              }
          }, (errorResponse: any) => {
              this.handleError(errorResponse.error.message.information);
          });
    }

    getPromotions(){
      this.loadingPromos$.next(true);
      this.promotionService.getPromotions()
            .subscribe((promotions: Promotion[]) => {
                this.promosAll$.next(promotions);
                this.hasPromos$.next(promotions.length > 0);
                this.loadingPromos$.next(false);
            });
    }

    removePromotion(promotion: Promotion){
        return this.dialog
            .open(DialogConfirmationComponent, {
                data: {
                    message: 'Deleting this promotion will also permanently remove all records related to it. This action cannot be undone! Are you sure you want to delete promotion "' + promotion.name + '"?',
                },
                width: '600px',
                role: 'dialog'
            })
            .afterClosed()
            .subscribe(respCode => {
                switch (respCode) {
                    case -1: // Return button
                        break;
                    case 0: // Complete
                        break;
                    case 1: // Complete
                        this.promotionService.removePromotion(promotion.id)
                            .subscribe((response: any) => {
                                if (!response.error){
                                    this.snackBar.open('Operation successfully completed!', null, {duration: 1000});
                                    this.getWebsites();
                                    this.getPromotions();
                                }else{
                                    this.snackBar.open('An error occurred!', null, {duration: 1000});
                                }
                            });
                        break;
                }
            });
    }

    editPromotion(promotion: Promotion) {
        if (promotion === null) {
            promotion = Promotion.emptyPromotion();
        }
        return this.dialog
            .open(DialogNewPromotionComponent, {
                data: {
                    promotion: promotion,
                },
                width: '600px',
                role: 'dialog'
            })
            .afterClosed()
            .subscribe(respCode => {
                switch (respCode) {
                    case -1: // Return button
                        break;
                    case 0: // Complete
                        this.snackBar.open('An error occurred!', null, {duration: 1000});
                        break;
                    case 1: // Complete
                        this.snackBar.open('Operation successfully completed!', null, {duration: 1000});
                        this.getPromotions();
                        break;
                }
            });
    }

    unlinkPromo(website: Website){
        return this.dialog
            .open(DialogConfirmationComponent, {
                data: {
                    message: 'You are about to remove the promo from website "' + website.name + '". Are you sure?',
                },
                width: '600px',
                role: 'dialog'
            })
            .afterClosed()
            .subscribe(respCode => {
                switch (respCode) {
                    case -1: // Return button
                        break;
                    case 0: // Complete
                        break;
                    case 1: // Complete
                        this.promotionService.updateSiteLinkedPromotion(website.id, -1)
                            .subscribe((response: any) => {
                                if (!response.error){
                                    this.snackBar.open('Operation successfully completed!', null, {duration: 1000});
                                    this.getWebsites();
                                }else{
                                    this.snackBar.open('An error occurred!', null, {duration: 1000});
                                }
                            });
                        break;
                }
            });
    }

    handleError(errorInformation: string){
        return this.dialog
            .open(DialogErrorComponent, {
                data: {
                    error: errorInformation,
                },
                width: '600px',
                role: 'dialog'
            })
            .afterClosed()
            .subscribe();
    }

}
